import React, { useState } from 'react';
import i18next from '../../i18n.js';

const ChevronIcon = (props) => (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#111111" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d={props.opened ? "M6 15l6-6 6 6" : "M6 9l6 6 6-6"} />
    </svg>
);

const CollapsedSelectInput = (props) => {
    const [opened, setOpened] = useState(false);

    const { name, value, values, placeholder, disabled } = props;

    const options = values?.data?.filter(item => !item.hidden) ?? [];
    const selected = options.find(item => item.value === value);

    const selectHandle = (item) => {
        setOpened(false);
        if (item.value !== value && props.onChange) {
            props.onChange({
                target: {
                    name: name,
                    value: item.value
                }
            });
        }
    }

    return (<div className={"collapsed-select" + (disabled ? " disabled" : "")}>
        <div className="collapsed-select-control" onClick={() => { if (!disabled) setOpened(!opened) }}>
            <span className={selected?.label ? '' : 'empty'}>{selected?.label || placeholder || i18next.t('other.selectFieldEmptyLabel')}</span>
            <ChevronIcon opened={opened} />
        </div>
        {/* список рендериться завжди, а показує його клас opened: на великих екранах
            варіанти видно одразу, тому там розгортання вмикається стилями */}
        {!disabled && <div className={"collapsed-select-items" + (opened ? " opened" : "")}>
            {options.map(item =>
                <div className={"collapsed-select-item" + (item.value === value ? " selected" : "")} key={item.value} onClick={() => selectHandle(item)}>
                    <span>{item.label}</span>
                    <div className={'radio' + (item.value === value ? ' checked' : '')} />
                </div>
            )}
        </div>}
    </div>);
}

export default CollapsedSelectInput;
